import React, { Component } from 'react';
import { connect } from 'react-redux';
import TransactionsFiltersView from './TransactionFilters.view';

export class TransactionsFiltersContainer extends Component {
  render() {
    return (<TransactionsFiltersView
      {...this.props}
    />);
  }
}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps)(TransactionsFiltersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Transactions/TransactionFilters/TransactionFilters.container.js